import './flights-table.scss';
import { createElementFromHTML } from '../../utilities/js/helper';

class FlightsTable {
    constructor(element) {
        this.$flightsTable = element;
        this.$flightsTableTargets = this.$flightsTable.querySelector('[data-flights-table="targets"]');
        this.$flightsTableSwitch = this.$flightsTable.querySelector('[data-flights-table="switch"]');
        this.$$arrivals = [];
        this.$$departures = [];
        this.$$filters = this.$flightsTable.querySelectorAll('[data-flights-table-filter]');
        this.$searchForm = this.$flightsTable.querySelector('[data-flights-table="search-form"]');
        this.$searchInput = this.$flightsTable.querySelector('[data-flights-table="search-input"]');
        this.$nothingFound = this.$flightsTable.querySelector('[data-flights-table="not-found"]');
        this.$resultsFoundMessage = this.$flightsTable.querySelector('[data-flights-table-live-results="true"]');
        this.$noResultsFoundMessage = this.$flightsTable.querySelector('[data-flights-table-live-results="false"]');
        this.$laterFilter = this.$flightsTable.querySelector('.flights-table__filter-later');
        this.$previousFilter = this.$flightsTable.querySelector('.flights-table__filter-earlier');
        this.$departuresCount = this.$flightsTableSwitch.querySelector('[data-flights-table-found-departures]');
        this.$arrivalsCount = this.$flightsTableSwitch.querySelector('[data-flights-table-found-arrivals]');
        this.arrivalsFound = 0;
        this.departuresFound = 0;

        this.$loader = createElementFromHTML(window.OPTIONS.loader);
        this.searchParams = new URLSearchParams(window.location.search);

        this.activeFilters = {
            traffic: this.$flightsTableSwitch.querySelector('[data-flights-table-target].is--active')?.dataset.flightsTableTarget,
            category: 'current',
            day: 'today',
            count: 12
        };

        const startDate = new Date(Date.now());
        const endDate = new Date(Date.now() + 48 * 60 * 60 * 1000); // +2 Day

        this.dateStart = this.formatDate(startDate);
        this.dateEnd = this.formatDate(endDate);
        this.apiHost = 'https://fsg-datahub.azure-api.net/';

        this.arrivalUrl = `${this.apiHost}legacy/ArrivalFlights/Get?from=${this.dateStart}&till=${this.dateEnd}&pagesize=999&page=1`;
        this.departureUrl = `${this.apiHost}legacy/DepartureFlights/Get?from=${this.dateStart}&till=${this.dateEnd}&pagesize=999&page=1`;

        this.waitTableTiming = null;
        this.inputTimeout = null;
        this.searchActive = false;
        this.animationSpeed = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--animation-speed').trim()) * 1000;
    }

    initialize () {
        this.getUrlParameters();

        const flightsResponse = this.getNextFlights();

        flightsResponse.then((success) => {
            if (success) {
                this.setEvents();
                this.handleTableRoleConcept(true);
                this.setFilter('departures', this.activeFilters.category, this.activeFilters.day, this.activeFilters.count, this.$searchInput.value.toLowerCase());
                this.setFilter('arrivals', this.activeFilters.category, this.activeFilters.day, this.activeFilters.count, this.$searchInput.value.toLowerCase());

                this.checkPrevNextFlights();
            }
        });
    }

    // format time stamp to a simple date string like this "2025-10-07"
    formatDate (date) {
        const dateObj = new Date(date);
        return dateObj.toISOString().split("T")[0];
    }

    getUrlParameters () {
        this.searchParams = new URLSearchParams(window.location.search);

        if (this.searchParams.get('count')) {
            this.activeFilters.count = (this.searchParams.get('count') === '*') ? '*' : parseInt(this.searchParams.get('count'));
        }

        if (this.searchParams.get('category')) {
            this.activeFilters.category = (this.searchParams.get('category') === 'next') ? 'current' : this.searchParams.get('category');

            if (this.searchParams.get('category') === 'next') {
                this.activeFilters.count = '*';
            }
        }

        if (this.searchParams.get('traffic')) {
            this.activeFilters.traffic = this.searchParams.get('traffic');
        }

        if (this.searchParams.get('day')) {
            this.activeFilters.day = this.searchParams.get('day');
        }

        if (this.searchParams.get('searchTerm') && this.$searchInput) {
            this.$searchInput.value = this.searchParams.get('searchTerm');
            this.setFilter(this.activeFilters.traffic, 'previous', this.activeFilters.day,'*', this.$searchInput.value.toLowerCase());
        }
    }

    checkPrevNextFlights () {
        let active = (this.activeFilters === 'departures') ? 'departure' : 'arrival';
        const prevFlights = this.$flightsTable.querySelectorAll(`[data-flights-table-traffic="${active}"].flights-table__item[data-flights-category="previous"]`).length;
        const nextFlights = this.$flightsTable.querySelectorAll(`[data-flights-table-traffic="${active}"]:not([data-flights-category="previous"]).flights-table__item.is--deactive`).length;

        if (nextFlights <= 0 || this.$searchInput.value !== '') {
            this.$flightsTable.querySelector('.flights-table__filter-earlier')?.classList.add('is--disabled');
        } else {
            this.$flightsTable.querySelector('.flights-table__filter-earlier')?.classList.remove('is--disabled');
        }

        if (prevFlights <= 0 || this.$searchInput.value !== '') {
            this.$flightsTable.querySelector('.flights-table__filter-later')?.classList.add('is--disabled');
        } else {
            this.$flightsTable.querySelector('.flights-table__filter-later')?.classList.remove('is--disabled');
        }
    }

    setEvents () {
        if (this.$flightsTableSwitch) {
            this.$flightsTableSwitch.addEventListener('click', (e) => {
                const traffic = e.target.dataset.flightsTableTarget;

                // get all triggers and clear all
                const $$allTriggerBtn = this.$flightsTableSwitch.querySelectorAll('[data-flights-table-target]');
                $$allTriggerBtn.forEach($triggerBtn => {
                    if ($triggerBtn.classList.contains('is--active')) {
                        $triggerBtn.classList.remove('is--active');
                        $triggerBtn.removeAttribute('disabled');
                    }
                });

                e.target.setAttribute('disabled', 'disabled');

                if (traffic && !e.target.classList.contains('is--active')) {
                    clearInterval(this.waitTableTiming);

                    const $openTable = this.$flightsTableTargets.querySelector('[data-flights-table-container].is--active');
                    const $flightsTableTarget = this.$flightsTableTargets.querySelector(`[data-flights-table-container="${traffic}"]`);
                    this.activeFilters.traffic = traffic;

                    if (this.$searchInput && this.$searchInput.value !== '') {
                        this.setFilter(this.activeFilters.traffic, 'previous', this.activeFilters.day,'*', this.$searchInput.value.toLowerCase());
                    }

                    const showTables = () => {
                        this.$flightsTableTargets.style.transitionDuration = '0s';
                        this.$flightsTableTargets.style.maxHeight = $openTable?.clientHeight + 'px';
                        this.$flightsTableSwitch.querySelector('.flights-table__button.is--active')?.classList.remove('is--active');
                        e.target.classList.add('is--active');

                        $openTable?.classList.remove('is--active');
                        $flightsTableTarget?.classList.add('is--active');

                        this.$flightsTableTargets.style.transitionDuration = '';
                        this.$flightsTableTargets.style.maxHeight = $flightsTableTarget?.clientHeight + 'px';

                        this.waitTableTiming = setTimeout(() => {
                            this.$flightsTableTargets.style.maxHeight = '';
                        }, this.animationSpeed);
                    };

                    if (this.$nothingFound) {
                        if (!this.$nothingFound.classList.contains('is--visible')) {
                            showTables();
                        } else {
                            e.target.classList.add('is--active');
                        }
                    } else {
                        showTables();
                    }

                    this.checkPrevNextFlights();
                }
            });
        }

        this.setHistoryBeforeLeave();

        if (this.$$filters.length > 0) {
            this.$$filters.forEach((filter) => {
                filter.addEventListener('click', (e) => {
                    const filters = filter.dataset.flightsTableFilter.split(',');

                    if (this.$searchInput.value !== '') {
                        filters[2] = '*';
                        filters[0] = 'previous';
                    }

                    if (filters[1] !== '*' && this.activeFilters.day !== filters[1]) {
                        this.activeFilters.day = filters[1];
                    }

                    this.activeFilters.count = filters[2];
                    this.activeFilters.category = filters[0];

                    this.setFilter(this.activeFilters.traffic, filters[0], this.activeFilters.day, filters[2], this.$searchInput.value.toLowerCase());
                    if ((filters[0] === 'previous' || filters[2] === '*') && (filter.classList.contains('flights-table__filter-earlier') || filter.classList.contains('flights-table__filter-later'))) {
                        filter.classList.add('is--disabled');
                    }

                    if (filter.classList.contains('flights-table__filter-item')) {
                        this.$flightsTable.querySelector('[data-flights-table-filter].is--active')?.classList.remove('is--active');
                        filter.classList.add('is--active');
                    }
                });
            });
        }

        if (this.$searchInput) {
            this.$searchInput.addEventListener('input', () => {
                clearTimeout(this.inputTimeout);
                this.inputTimeout = setTimeout(() => {
                    const searchTerm = this.$searchInput.value.toLowerCase();

                    if (searchTerm.length >= 1) {
                        this.searchActive = true;
                        this.setFilter(this.activeFilters.traffic, 'previous', this.activeFilters.day, '*', searchTerm);
                    } else {
                        this.searchActive = false;
                        this.setFilter(this.activeFilters.traffic, 'current', this.activeFilters.day, 12, searchTerm);
                    }
                }, 300);
            });

            this.$searchForm.addEventListener('submit', (e) => {
                e.preventDefault();
            });
        }
    }

    countTrafficFound (traffic) {
        if (traffic === 'departures') {
            this.departuresFound = this.departuresFound + 1;
        } else if (traffic === 'arrivals') {
            this.arrivalsFound = this.arrivalsFound + 1;
        }
    }

    resetTrafficFound () {
        this.departuresFound = 0;
        this.arrivalsFound = 0;
        this.$departuresCount.innerHTML = '';
        this.$arrivalsCount.innerHTML = '';
    }

    setCategory (planDate, estimate) {
        const now = new Date();
        const startTime = new Date(now.getTime() - 30 * 60 * 1000);

        if ((this.formatStringToDate(planDate).getTime() > startTime.getTime()) || (estimate !== null && this.formatStringToDate(estimate).getTime() > startTime.getTime())) {
            return 'current';
        } else {
            return 'previous';
        }
    }

    setFilter (traffic, category, day, count, searchTerm= '') {
        this.$$arrivals = this.$flightsTable.querySelectorAll('[data-flights-table-traffic="arrival"].flights-table__item');
        this.$$departures = this.$flightsTable.querySelectorAll('[data-flights-table-traffic="departure"].flights-table__item');

        if (!traffic || !category || !day || !count) {
            return false;
        }

        count = (count === '*') ? 1000 : parseInt(count);
        category = category === 'previous' ? ['previous', 'current'] : category;
        day = day === '*' ? ['today', 'tomorrow'] : day;

        const searchNode = (traffic === 'departures') ? this.$$departures : this.$$arrivals;
        let displayFlights = false;
        let found = 0;
        let searchFound = true;
        let tomorrowFound;

        if (searchTerm !== '') {
            this.resetTrafficFound();
        }

        searchNode.forEach((item) => {
            if (searchTerm !== '') {
                searchFound = item.dataset.filter.toLowerCase().includes(searchTerm);

                if (category.includes(item.dataset.flightsCategory) && ['today', 'tomorrow'].includes(item.dataset.flightsDay) && found < count && searchFound === true) {
                    tomorrowFound = true;
                } else {
                    tomorrowFound = false;
                }
            }

            if (category.includes(item.dataset.flightsCategory) && day.includes(item.dataset.flightsDay) && found < count && searchFound === true) {
                if (item.classList.contains('is--deactive')) {
                    item.classList.remove('is--deactive');
                }

                if (item.dataset.flightsCategory !== 'previous') {
                    found++;
                }

                this.countTrafficFound(traffic);
                displayFlights = true;
            } else {
                if (!item.classList.contains('is--deactive')) {
                    item.classList.add('is--deactive');
                }

                if (tomorrowFound) {
                    this.countTrafficFound(traffic);
                }
            }
        });

        if (searchTerm !== '') {
            const searchForCountTraffic = (traffic === 'departures') ? 'arrivals' : 'departures';
            const searchForCountNode = (traffic === 'departures') ? this.$$arrivals : this.$$departures; // Search in other Target too, if SearchTerm (for Counting purposes)

            searchForCountNode.forEach((item) => {
                if (category.includes(item.dataset.flightsCategory) && ['today', 'tomorrow'].includes(item.dataset.flightsDay) && found < count && item.dataset.filter.toLowerCase().includes(searchTerm)) {
                    this.countTrafficFound(searchForCountTraffic);
                }
            });
        }

        if (count === 1000) {
            this.$laterFilter.classList.add('is--disabled');
        } else {
            this.$laterFilter.classList.remove('is--disabled');
        }

        if (category.includes('previous') || day === 'tomorrow') {
            this.$previousFilter.classList.add('is--disabled');
        } else {
            this.$previousFilter.classList.remove('is--disabled');
        }

        if (searchTerm !== '') {
            this.$departuresCount.innerHTML = `(${this.departuresFound})`;
            this.$arrivalsCount.innerHTML = `(${this.arrivalsFound})`;

            if (this.departuresFound > 0 || this.arrivalsFound > 0) {
                this.handleLiveRegions(true, false, (this.departuresFound + this.arrivalsFound), searchTerm);
            } else {
                this.handleLiveRegions(false, true);
            }
        } else {
            this.resetTrafficFound();
        }

        this.displayFlights(displayFlights);
    }

    handleLiveRegions (stateResults, stateNoResults, searchCount, searchParam) {
        if (searchCount > 0) {
            this.$resultsFoundMessage.textContent = `${searchCount} ${this.$resultsFoundMessage.dataset.flightsTableResultMessage} ${searchParam}`;
        }

        this.$resultsFoundMessage.setAttribute('aria-hidden', stateNoResults);
        this.$noResultsFoundMessage.setAttribute('aria-hidden', stateResults);
    }

    displayFlights (state) {
        if (state) {
            this.$nothingFound.classList.remove('is--visible');
            this.$flightsTableTargets.querySelector(`[data-flights-table-target="${this.activeFilters.traffic}"]`)?.classList.add('is--active');
        } else {
            this.$nothingFound.classList.add('is--visible');
            this.$flightsTableTargets.querySelector('[data-flights-table-target].is--active')?.classList.remove('is--active');
        }
    }

    formatStringToDate (dateStr) {
        return new Date(dateStr);
    }

    formatDateToTime (dateStr, local = 'de-DE') {
        return new Date(dateStr).toLocaleTimeString(local, {
            hour: "2-digit",
            minute: "2-digit"
        });
    }

    loadFlights (fetchURL, $targetContainer, targetName) {
        $targetContainer.appendChild(this.$loader);

        return fetch(fetchURL, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok && response.status !== 422) {
                    throw new Error(`HTTP ERROR: ${response.status}`);
                }
                return response.text();
            })
            .then(data => {
                if (data) {
                    const $loader = $targetContainer.querySelector('.loading');

                    if ($loader) {
                        $loader.classList.add('is--hidden');

                        setTimeout(() => {
                            $loader.remove();
                        }, 400);
                    }

                    const flightData = JSON.parse(data);

                    const $wrapper = document.createElement('div');
                    const $targetWrapper = document.createElement('div');
                    const $tableHeader = document.createElement('div');
                    const $tableWrapper = document.createElement('div');

                    $targetWrapper.classList.add('flights-table__table');
                    $targetWrapper.setAttribute('data-role', 'table');

                    $tableHeader.classList.add('flights-table__table-rowgroup');
                    $tableHeader.setAttribute('data-role', 'rowgroup');

                    $tableWrapper.classList.add('flights-table__cells');
                    $tableWrapper.setAttribute('data-role', 'rowgroup');

                    // create arrivals header
                    if (targetName === 'arrivals') {
                        $tableHeader.innerHTML = `
                            <div role="row" class="flights-table__table-header" data-flights-table-traffic="arrival">
                                <div role="columnheader">${window.translations.flightsTable.header_arrival}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_from}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_flight_nr}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_aircraft}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_terminal}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_status}</div>
                            </div>
                        `;
                    }

                    // create departures header
                    if (targetName === 'departures') {
                        $tableHeader.innerHTML = `
                            <div role="row" class="flights-table__table-header" data-flights-table-traffic="departure">
                                <div role="columnheader">${window.translations.flightsTable.header_departure}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_to}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_flight_nr}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_aircraft}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_terminal}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_checkin}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_gate}</div>
                                <div role="columnheader">${window.translations.flightsTable.header_status}</div>
                            </div>
                        `;
                    }

                    $targetWrapper.appendChild($tableHeader);

                    if (typeof flightData === 'object' && flightData.Items && flightData.Items.length > 0) {
                        // create arrivals table
                        if (targetName === 'arrivals') {
                            flightData.Items.forEach((flight, i) => {
                                const $flightWrapper = document.createElement('div');
                                $flightWrapper.classList.add('flights-table__item');
                                $flightWrapper.classList.add('is--deactive');
                                $flightWrapper.setAttribute('data-role', 'row');
                                $flightWrapper.setAttribute('data-aria-rowindex', (i+1));
                                $flightWrapper.setAttribute('data-flights-table-traffic', 'arrival');
                                $flightWrapper.setAttribute('data-flights-day', this.formatDate(flight.Plan) == this.dateStart ? 'today' : 'tomorrow');
                                $flightWrapper.setAttribute('data-flights-category', this.setCategory(flight.Plan, flight.Estimate));
                                $flightWrapper.setAttribute('data-filter', `${flight.Name} ${flight.Origin !== undefined ? flight.Origin.Name : ''}`);

                                $flightWrapper.innerHTML = `
                                    <div data-role="cell" class="flights-table__cell-estimate${flight.Estimate !== null ? ' is--estimated' : ''}">
                                        <div>
                                            <span class="is--plan">${this.formatDateToTime(flight.Plan)}</span>
                                        </div>
                                        ${flight.Estimate !== null ? `<span class="is--late">${this.formatDateToTime(flight.Estimate)}</span>` : ''}
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-from"><p>${flight.Origin !== undefined ? flight.Origin.Name : ''}</p></div>
                                    <div data-role="cell" class="flights-table__cell-airline"><p>${flight.Name}</p></div>
                                    <div data-role="cell" class="flights-table__cell-aircraft">
                                        <p>
                                            <span class="flights-table__cell-mobile-category">${window.translations.flightsTable.header_aircraft}</span>
                                            ${flight.Aircraft}
                                        </p>
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-terminal">
                                        <p>
                                            <span class="flights-table__cell-mobile-category">${window.translations.flightsTable.header_terminal}</span>
                                            ${flight.Terminal}
                                        </p>
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-status">
                                         ${ flight.Status !== 'none' ? `
                                            <span class="tag tag--${ flight.Status === 'cancelled' ? 'flight-red' : 'flight-black'}">
                                                <span>${window.translations.flightsTable['status_' + flight.Status]}</span>
                                            </span>
                                        ` : ''}
                                    </div>
                                `;
                                $tableWrapper.appendChild($flightWrapper);
                            });
                        }

                        // create departures table
                        if (targetName === 'departures') {
                            flightData.Items.forEach((flight, i) => {
                                const $flightWrapper = document.createElement('div');
                                $flightWrapper.classList.add('flights-table__item');
                                $flightWrapper.classList.add('is--deactive');
                                $flightWrapper.setAttribute('data-role', 'row');
                                $flightWrapper.setAttribute('data-aria-rowindex', (i+1));
                                $flightWrapper.setAttribute('data-flights-table-traffic', 'departure');
                                $flightWrapper.setAttribute('data-flights-day', 'today');
                                $flightWrapper.setAttribute('data-flights-category', this.setCategory(flight.Plan, flight.Estimate));
                                $flightWrapper.setAttribute('data-filter', `${flight.Name} ${flight.Destination !== undefined ? flight.Destination.Name : ''}`);

                                $flightWrapper.innerHTML = `
                                    <div data-role="cell" class="flights-table__cell-estimate${flight.Estimate !== null ? ' is--estimated' : ''}">
                                        <div>
                                            <span class="is--plan">${this.formatDateToTime(flight.Plan)}</span>
                                        </div>
                                        ${flight.Estimate !== null ? `<span class="is--late">${this.formatDateToTime(flight.Estimate)}</span>` : ''}
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-from"><p>${flight.Destination !== undefined ? flight.Destination.Name : ''}</p></div>
                                    <div data-role="cell" class="flights-table__cell-airline"><p>${flight.Name}</p></div>
                                    <div data-role="cell" class="flights-table__cell-aircraft">
                                        <p>
                                            <span class="flights-table__cell-mobile-category">${window.translations.flightsTable.header_aircraft}</span>
                                            ${flight.Aircraft}
                                        </p>
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-terminal">
                                        <p>
                                            <span class="flights-table__cell-mobile-category">${window.translations.flightsTable.header_terminal}</span>
                                            ${flight.Terminal}
                                        </p>
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-checkin">
                                        <p>
                                            <span class="flights-table__cell-mobile-category">${window.translations.flightsTable.header_checkin}</span>
                                            ${flight.Checkin}
                                        </p>
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-gate">
                                        <span class="flights-table__cell-mobile-category">${window.translations.flightsTable.header_gate}</span>
                                        <p>
                                            <span>${flight.Gate}</span>
                                        </p>
                                    </div>
                                    <div data-role="cell" class="flights-table__cell-status">
                                        ${ flight.Status !== 'none' ? `
                                            <span class="tag tag--${ flight.Status === 'cancelled' ? 'flight-red' : 'flight-black'}">
                                                <span>${window.translations.flightsTable['status_' + flight.Status]}</span>
                                            </span>
                                        ` : ''}
                                    </div>
                                `;
                                $tableWrapper.appendChild($flightWrapper);
                            });
                        }
                    }

                    $targetWrapper.appendChild($tableWrapper);
                    $wrapper.appendChild($targetWrapper);

                    $targetContainer.innerHTML = $wrapper.innerHTML;
                    return true;
                } else {
                    return false;
                }
            })
            .catch(error => {
                console.error("ERROR:", error);
                return false;
            });
    }

    async getNextFlights () {
        const $departures = this.$flightsTable.querySelector('[data-flights-table-container="departures"]');
        const $arrivals = this.$flightsTable.querySelector('[data-flights-table-container="arrivals"]');

        const promises = [];

        if ($departures) {
            promises.push(this.loadFlights(this.departureUrl, $departures, 'departures'));
        }

        if ($arrivals) {
            promises.push(this.loadFlights(this.arrivalUrl, $arrivals, 'arrivals'));
        }

        const results = await Promise.all(promises);
        return results.every(Boolean);
    }

    handleTableRoleConcept (state) {
        const $$allRoleItems = this.$flightsTable.querySelectorAll('[data-role]');

        if ($$allRoleItems.length > 0) {
            $$allRoleItems.forEach(($roleItem) => {
                if (state === true) {
                    $roleItem.setAttribute('role', $roleItem.dataset.role);
                }

                if (state === false) {
                    $roleItem.removeAttribute('role');
                }
            });
        }

        const $$allAriaRow = this.$flightsTable.querySelectorAll('[data-aria-rowindex]');

        if ($$allAriaRow.length > 0) {
            $$allAriaRow.forEach(($ariaRow) => {
                if (state === true) {
                    $ariaRow.setAttribute('aria-rowindex', $ariaRow.dataset.ariaRowindex);
                }

                if (state === false) {
                    $ariaRow.removeAttribute('aria-rowindex');
                }
            });
        }
    }

    setHistoryBeforeLeave () {
        this.$flightsTableTargets.querySelectorAll('a').forEach(($link) => {
            $link.addEventListener('click', () => {
                let getParams = '';
                let index = 0;

                for (const [key, value] of Object.entries(this.activeFilters)) {
                    getParams += (index === 0) ? '?' : '&';
                    getParams += `${key}=${encodeURIComponent(value.toString())}`;
                    index++;
                }

                if (this.$searchInput && this.$searchInput.value !== '') {
                    getParams += '&searchTerm=' + encodeURIComponent(this.$searchInput.value);
                }

                history.replaceState(null, '', window.location.pathname + getParams);
            });
        });
    }
}

export default FlightsTable;

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $flightsTable = $context.querySelector('[data-flights-table="root"]');

    if ($flightsTable) {
        const flightsTable = new FlightsTable($flightsTable);
        flightsTable.initialize();
    }
});